var React = require('react');

function CaseArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 5.57047C0 5.6446 0.0539958 5.7047 0.120603 5.7047L6.03015 5.7047H9.30319C9.40972 5.7047 9.46393 5.84717 9.38981 5.93232L6.04737 9.77238C5.97325 9.85753 6.02747 10 6.134 10H7.42791C7.45961 10 7.49004 9.9861 7.51261 9.96132L11.9641 5.07298C11.9871 5.04776 12 5.01334 12 4.97743V4.95546C12 4.91955 11.9871 4.88513 11.9641 4.85991L7.57291 0.0386715C7.55034 0.0138928 7.51992 2.30968e-07 7.48821 2.30968e-07H6.13715C6.03016 2.30968e-07 5.97615 0.143516 6.05119 0.22838L9.386 3.99981C9.46104 4.08467 9.40702 4.22819 9.30004 4.22819H6.03015L0.120603 4.22819C0.0539957 4.22819 0 4.28828 0 4.36242L0 5.57047Z","fill":"white"}));
}

CaseArrowIconInline.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = CaseArrowIconInline;

CaseArrowIconInline.default = CaseArrowIconInline;
